export const passwordCriteria = {
    length: /^.{8,30}$/,
    uppercase: /[A-Z]/,
    lowercase: /[a-z]/,
    special: /^(?=[^0-9\s!\\\""#\$%&'()*+,-.\/:;<=>\?@\[\]^_`{|}~]*[0-9\s!\\\""#\$%&'()*+,-.\/:;<=>\?@\[\]^_`{|}~]).*$/,
};

export const validatePassword = (password: string): boolean => {
    const allCriteria: boolean[] = [];
    for (const criteriaItem in passwordCriteria) {
        const meetsCriteria = password.match(passwordCriteria[criteriaItem]) !== null;
        allCriteria.push(meetsCriteria);
    }
    return allCriteria.every((criteria) => criteria === true);
};
